import React from 'react';
import { PopUp } from '../PopUp';

interface CreditsProps {
  closeCallback: () => void;
}

export class Credits extends React.Component<CreditsProps> {
  render(): React.ReactNode {
    return (
      <PopUp closeCallback={() => this.props.closeCallback()}>
        <h2 className='w-3/4 text-center text-md md:text-xl'> Created by Jacob Harmon </h2>
      </PopUp>
    );
  }
}
